import React, {Component} from 'react';
import axios from 'axios';
import config from '../../config.json';
import {Chart as ChartJS,CategoryScale,LinearScale,BarElement,Title,Tooltip,Legend,} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import MemberTrait from './MemberTrait';
import MemberUnit from './MemberUnit';
import MemberClassementChart from './MemberClassementChart';
import MatchsUnitDisplay from './MatchsUnitDisplay';
import MemberAugment from './MemberAugment';
import MemberItems from './MemberItems';

ChartJS.register(CategoryScale,LinearScale,BarElement,Title,Tooltip,Legend,ChartDataLabels);

class MemberStatDetails extends Component{
    constructor() {
        super();
        this.state = { augments: null,matches: null,matchData: null,traitData: null,unitData: null,last20units: null,last20Traits: null};
        this.options = {
            plugins: {
                datalabels: {
                    display: function(context) {
                        return context.dataset.data[context.dataIndex] !== 0; // or >= 1 or ...
                    },
                    formatter: function(value, context) {
                        //return context.dataIndex + '%';
                        return context.dataset.data[context.dataIndex] + '%'
                      }
                },
                tooltip: {
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
    
                            if (label) {
                                label += ': ';
                            }
                            if (context.parsed.y !== null) {
                                label += context.parsed.y + '%';
                            }
                            return label;
                        }
                    }
                }
                
            }  
        }
    }
    
    componentDidMount() {
        axios.get(`${config.base_url}/api/matches/${this.props.puuid}`)
          .then(res => {
            const data = res.data;
            let tableResult = {"top1":0,"top2":0,"top3":0,"top4":0,"top5":0};
            data.match.forEach(function(match) {
                if(match.placement === 1) {
                    tableResult.top1 += 1
                }
                if(match.placement === 2) {
                    tableResult.top2 += 1
                }
                if(match.placement === 3) {
                    tableResult.top3 += 1
                }
                if(match.placement === 4) {
                    tableResult.top4 += 1
                }
                if(match.placement >= 5) {
                    tableResult.top5 += 1
                }
            })
            let nbMatch = data.match.length
            let matchResult = [
                ((tableResult.top1/nbMatch)* 100).toFixed(1),
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top1/20)* 100),
                ((tableResult.top2/nbMatch)*100).toFixed(1), 
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top2/20)*100), 
                ((tableResult.top3/nbMatch)*100).toFixed(1),
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top3/20)*100),
                ((tableResult.top4/nbMatch)*100).toFixed(1),
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top4/20)*100),
                ((tableResult.top5/nbMatch)*100).toFixed(1)
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top5/20)*100)
            ];
            tableResult = {"top1":0,"top2":0,"top3":0,"top4":0,"top5":0};

            let cpt = 0;
            data.saison.forEach(function(match) {
                if(match.placement === 1) {
                    tableResult.top1 += 1
                }
                if(match.placement === 2) {
                    tableResult.top2 += 1
                }
                if(match.placement === 3) {
                    tableResult.top3 += 1
                }
                if(match.placement === 4) {
                    tableResult.top4 += 1
                }
                if(match.placement >= 5) {
                    tableResult.top5 += 1
                }
                cpt++;
            })
            let saisonResult = [
                ((tableResult.top1 / cpt) * 100).toFixed(1),
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top1 / cpt) * 100),
                ((tableResult.top2 / cpt) * 100).toFixed(1),
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top2 / cpt) * 100),
                ((tableResult.top3 / cpt) * 100).toFixed(1),
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top3 / cpt) * 100),
                ((tableResult.top4 / cpt) * 100).toFixed(1),
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top4 / cpt) * 100),
                ((tableResult.top5 / cpt) * 100).toFixed(1)
                //new Intl.NumberFormat('fr-FR',{ maximumSignificantDigits: 2 }).format((tableResult.top5 / cpt) * 100)
            ];
            
            let matchData = {
                labels: ['Top 1', 'Top 2', 'Top 3', 'Top 4', 'Top 5+'],
                datasets: [
                    {
                        datalabels: {
                            color: '#000000'
                        },
                        label: `${nbMatch} derniers matchs`,
                        data: matchResult,
                        backgroundColor: 'rgba(228, 184, 73, 0.4)',
                        borderColor: 'rgba(179, 129, 0, 1)',
                        borderWidth: 1,
                    },
                    {
                        datalabels: {
                            color: '#FFFFFF'
                        },
                        label: 'Saison ('+cpt+' matches)',
                        data: saisonResult,
                        backgroundColor: 'rgba(1, 19, 43, 0.4)',
                        borderColor: 'rgba(0, 0, 0, 1)',
                        borderWidth: 1,
                    }
                ],
            };

            let traitStat = [];
            
            let temp = data.traits;
            temp.forEach((traitMatch) => {
                traitMatch.forEach((trait) => {
                    if(trait.style !== 0) {

                        if(traitStat.find((item) => item.name === trait['name']) === undefined) {
                            // on à pas encore se trait dans le tableau
                            traitStat.push({'name': trait['name'],'total':0,'tier1':0,'tier2':0,'tier3':0,'tier4':0});
                        } else {
                            traitStat.find((item) => item.name === trait['name'])['tier'+trait.style] += 1
                            traitStat.find((item) => item.name === trait['name'])['total'] += 1
                        }
                    }
                });
            });
            //console.log(traitStat);
            traitStat
                .sort((a, b) =>{
                    if(a.total < b.total) {
                        return 1;
                    } else {
                        return -1;
                    }
                })
            
            let unitData = [];
            let itemData = [];
            let tempUnit = data.units;

            tempUnit.forEach((unitMatch) => {
                unitMatch.forEach((unit) => {
                    if(unitData.find((item) => item.name === unit['character_id']) === undefined) {
                        // on à pas encore l'unit dans le tableau
                        unitData.push({'name': unit['character_id'],'total':0,'tier':0});
                    } else {
                        //unitData.find((item) => item.name === unit['character_id'])['tier'+unit.style] += 1
                        unitData.find((item) => item.name === unit['character_id'])['total'] += 1
                        if(unit.items.length > 0) {
                            unit.items.forEach((item) => {
                                if(itemData.find((myItem) => item === myItem) === undefined) {
                                    itemData.push({"item": item,"total": 0,'unit': []});
                                }
                                itemData.find((myItem) => item === myItem.item)['total'] += 1
                                itemData.find((myItem) => item === myItem.item)['unit'].push(unit['character_id']);
                            })
                            
                        }
                    }
                })
            })
            unitData.sort((a,b) => {if(a.total < b.total) { return 1 } else {return -1}})
            itemData.sort((a,b) => {if(a.total < b.total) { return 1 } else {return -1}})

            this.setState({ items: itemData,augments: data.augments,matches: data.match,matchData: matchData,traitData: traitStat,unitData: unitData,last20units: data.units,last20Traits: data.traits})
          })
    }

    returnClassFromPlacement(placement) {
        switch (placement) {
            case 1:
                return "bg-aegis text-white border border-black rounded px-1 py-1";
            case 2:
                return "bg-lime-600 text-white rounded px-1 py-1";
            case 3:
                return "bg-lime-700 text-white rounded px-1 py-1";
            case 4:
                return "bg-lime-900 text-white rounded px-1 py-1"; //bg-amber-700
            case 5: case 6 : case 7 :
                return "bg-stone-400 text-white rounded px-1 py-1";
            case 8 :
                return "bg-[#d19c9c] text-white rounded px-1 py-1";
            default:
                return ""
        }
    }
    render() {
        //console.log(this.state.traitData);
        if(this.state.matches != null && this.state.last20Traits != null){
            return(
                <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-2 bg-white">
                    <div className='p-2'>
                        <h5 className='gold-aegis font-bold'>20 derniers résultats</h5>
                        <div className="w-full grid grid-rows-2 grid-cols-10 sm:grid-cols-5 md:grid-cols-10 lg:grid-cols-10 xl:grid-cols-10 gap-2 gap-y-2">
                    
                        {this.state.matches.map((match,index) => (
                            <div key={match.datetime} className={`text-center ${this.returnClassFromPlacement(match.placement)}`}>{match.placement}</div>
                        ))}
                        </div>
                        <div className="p-2 flex-col-2 justify-start" style={{ zIndex: 1, backgroundColor: 'white' }}>
                            <h5 className='gold-aegis font-bold'>Placements</h5>
                            {this.state.matchData != null ? <Bar data={this.state.matchData} options={this.options} /> : ""}
                            
                        </div>
                        <div className="p-2 flex-col-2 justify-start" style={{ zIndex: 1, backgroundColor: 'white' }}>
                            <h5 className='gold-aegis font-bold'>Evolution classement du jour</h5>
                            <MemberClassementChart key={"chart-"+this.props.name} puuid={this.props.puuid}/>                        
                        </div>
                        <div className="p-2 flex-col-2 justify-start" style={{ zIndex: 1, backgroundColor: 'white' }}>
                            <h5 className='gold-aegis font-bold'>TOP 10 Items (20 derniers matches)</h5>
                            <MemberItems key={"items-"+this.props.name} items={this.state.items}/>
                        </div>
                    </div>
                    <div className='p-2'>
                        <h5 className='gold-aegis font-bold'>10 derniers matchs</h5>
                            {this.state.last20units.slice(0,10).map((units,index) => (
                                <MatchsUnitDisplay key={index} index={index} units={units} augments={this.state.augments} matches={this.state.matches} traits={this.state.last20Traits}/>
                            ))}
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-x-2">
                    <div className="p-2 flex-col-2 justify-between">
                        <h5 className='gold-aegis font-bold mt-5'>TOP 10 Synergies (20 derniers matches)</h5>
                        <MemberTrait key={"trait-"+this.props.name} traits={this.state.traitData}/>
                    </div>
                    <div className="p-2 flex-col-2 justify-between">
                        <h5 className='gold-aegis font-bold mt-5'>TOP 10 Augments (20 derniers matches)</h5>
                        <MemberAugment key={"trait-"+this.props.name} augments={this.state.augments}/>
                    </div>
                    <div className="p-2 flex-col-2 justify-start">
                        <h5 className='gold-aegis font-bold mt-5'>TOP 10 Champions joués (20 derniers matches)</h5>
                        <MemberUnit key={"unit-"+this.props.name} units={this.state.unitData}/>
                    </div>
                    
                </div>
                </>
            )
        } else {
			return (
				<div className="flex justify-center justify-items-stretch">
					<div className="w-16 h-16 border-b-2 border-white-900 rounded-full animate-spin"></div>
				</div>
			)
		}
        
    }
}
export default MemberStatDetails